import { Clock, MapPin, Headset } from "lucide-react";
import OpeningExceptionBanner from "@/components/OpeningExceptionBanner";

export default function OpeningHoursBar() {
  return (
    <section className="bg-secondary border-y border-border">
      <div className="container mx-auto px-4 py-10">
        <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Jokela */}
          <div className="bg-muted/30 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                <MapPin className="text-primary" size={18} />
              </div>
              <div>
                <h4 className="font-display text-lg font-semibold text-foreground">Jokela</h4>
                <p className="text-muted-foreground text-xs">Keskustie 2</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <Clock size={14} className="text-primary" />
              <span className="text-foreground font-display font-semibold text-sm tracking-wider">Kulkukortti: 24/7</span>
            </div>
            <div className="border-t border-border pt-3">
              <div className="flex items-center gap-2 mb-2">
                <Headset size={14} className="text-primary" />
                <span className="text-foreground font-display font-semibold text-sm">Asiakaspalvelu</span>
              </div>
              <div className="space-y-1 text-sm">
                <div className="flex justify-between"><span className="text-muted-foreground">Maanantai</span><span className="text-foreground">16:00–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Tiistai</span><span className="text-foreground">16:00–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Torstai</span><span className="text-foreground">16:00–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Perjantai</span><span className="text-foreground">9:00–12:00</span></div>
              </div>
            </div>
          </div>

          {/* Kellokoski */}
          <div className="bg-muted/30 rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                <MapPin className="text-primary" size={18} />
              </div>
              <div>
                <h4 className="font-display text-lg font-semibold text-foreground">Kellokoski</h4>
                <p className="text-muted-foreground text-xs">Vanha Valtatie 195</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <Clock size={14} className="text-primary" />
              <span className="text-foreground font-display font-semibold text-sm tracking-wider">Kulkukortti: 05:00–22:00</span>
            </div>
            <div className="border-t border-border pt-3">
              <div className="flex items-center gap-2 mb-2">
                <Headset size={14} className="text-primary" />
                <span className="text-foreground font-display font-semibold text-sm">Asiakaspalvelu</span>
              </div>
              <div className="space-y-1 text-sm">
                <div className="flex justify-between"><span className="text-muted-foreground">Maanantai</span><span className="text-foreground">16:00–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Tiistai</span><span className="text-foreground">16:00–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Keskiviikko</span><span className="text-foreground">16:15–19:00</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Torstai</span><span className="text-foreground">9:00–12:00</span></div>
              </div>
            </div>
          </div>
        </div>
        <OpeningExceptionBanner />
        </div>
      </div>
    </section>
  );
}
